<!--Header-->
<div class="modal-header text-center" style="color: white;background-color: #0d47a1">
  <h4 class="modal-title w-100">{{x_titulo}}</h4>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
    <span aria-hidden="true" class="white-text">&times;</span>
  </button>
</div>

<!--Body-->
<div class="modal-body">
  <mdb-card>
        <mdb-card-header>Datos de la Constancia</mdb-card-header>
        <mdb-card-body>
            <div class="form-row mb-3" *ngIf="false">
                <div class="col-3">Código:</div>
                <div class="col-9">
                  <input mdbInput type="text" maxlength="20"  class="form-control" [(ngModel)]="id" placeholder="" readonly>
                </div>
            </div>

            <div class="form-row mb-3">
                <div class="col-3">Formato:</div>
                <div class="col-9">
                  <input mdbInput type="text" maxlength="50"  class="form-control" [(ngModel)]="maeConstanciaE.x_titulo" placeholder="Ejemplo: CONSTANCIA, CERTIFICADO" style="text-transform:uppercase">
                </div>
            </div>

            <div class="form-row mb-3">
              <div class="col-3">Curso de Aula Virtual:</div>
              <div class="col-9">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox"  [(ngModel)]="esCursoAV" (change)="onCursoOrigen()" [disabled]="esupdate ? true:null">
                </div>
              </div>
            </div>

          <div class="form-row mb-3" *ngIf="esupdate == false && esCursoAV">
            <div class="col-3">Categoria:</div>
            <div class="col-9">
              <select class="browser-default custom-select" [(ngModel)]="id_categoria"  (change)="onCategoriaChange()">
                <option value="0" selected>Seleccione</option>
                <option *ngFor="let listCat of listCategorias" [value]="listCat.id">{{listCat.nombre}}</option>
              </select>
            </div>
          </div>
          <div class="form-row mb-3" *ngIf="cursohabilitado">
            <div class="col-3">Curso:</div>
            <div class="col-9">
              <select class="browser-default custom-select" [(ngModel)]="idCurso" (change)="onCursoChange()">
                <option *ngFor="let listCurso of listCursos" [value]="listCurso.id">{{listCurso.nombre}}{{listCurso.participantes}}</option>
              </select>
            </div>
          </div>
          <div class="form-row mb-3"  *ngIf="esupdate || (!esCursoAV)">
            <div class="col-3">Curso:</div>
            <div class="col-9">
              <textarea mdbInput type="text" rows="2" maxlength="200"  class="form-control" [(ngModel)]="maeConstanciaE.x_curso" ></textarea>
            </div>
        </div>
          <div class="form-row mb-3">
            <div class="col-3">Fecha de constancia:</div>
            <div class="col-9">
              <div class="input-group">
                <input type="date" id="txtFecha" maxlength="10" min="2022-01-01" max="2030-12-31" [(ngModel)]="fecha_constancia" class="form-control" mdbInput>
              </div>
            </div>
        </div>
        <div class="form-row mb-3">
          <div class="col-3">Prefijo N° de constancia :</div>
          <div class="col-5">
            <input mdbInput type="text" maxlength="50"  class="form-control" [(ngModel)]="maeConstanciaE.x_prefijo_nro" placeholder="Ejemplo: D-2023, DPB-074-2023">
          </div>
          <div class="col-2">
              <button mdbBtn type="button" (click)="onInformacionPrefijo()" size="sm" class="px-3 btn  btn-blue btn-rounded" outline="true" mdbWavesEffect>
                <mdb-icon fas icon="info" size="md"></mdb-icon></button>
          </div>
      </div>
      <div class="form-row mb-3" *ngIf="esupdate">
        <div class="col-3">Estado :</div>
        <div class="col-9">
          <input mdbInput readonly type="text" maxlength="50"  class="form-control" [(ngModel)]="x_estado">
        </div>
    </div>


        <div class="form-row mb-3">
          <div class="col-3">Plantilla:</div>
          <div class="col-9" *ngIf="esupdate == false">
            <select class="browser-default custom-select" [(ngModel)]="c_plantilla" (change)="onPlantillaChange()">
              <option value="0" selected>Seleccione</option>
              <option *ngFor="let listPlantilla of listPlantillas" [value]="listPlantilla.c_plantilla">{{listPlantilla.x_nombre}}</option>
            </select>
          </div>
          <div class="col-9">
          <div *ngIf="seactualiza" class="custom-file">
              <input type="file" class="custom-file-input" multiple id="importFile" (change)="onFileChange($event.target.files)">
              <label class="custom-file-label" #labelArchivo for="importFile">Seleccionar archivo</label>
          </div>
          <div *ngIf="esupdate" class="input-group-append">
            <button *ngIf="seactualiza==false" mdbBtn type="button" (click)="onDescargarArchivo()" size="sm" class="btn btn-blue btn-rounded " mdbWavesEffect>
              <mdb-icon fas icon="download" class="mr-1"></mdb-icon>Descargar</button>
            <button *ngIf="seactualiza==false && maeConstanciaE.c_estado != 33" mdbBtn type="button" (click)="onMostrarActualizar(true)" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
              <mdb-icon fas icon="sync" class="mr-1"></mdb-icon>Actualizar</button>
            <button *ngIf="seactualiza" mdbBtn type="button" (click)="onMostrarActualizar(false)" size="sm" class="px-3 btn btn-blue btn-rounded" mdbWavesEffect>
              <mdb-icon fas icon="window-close" class="mr-1"></mdb-icon>Cancelar</button>
              <button *ngIf="seactualiza" mdbBtn type="button" (click)="onActualizarPlantilla()" size="sm" class="px-3 btn btn-teal btn-rounded" mdbWavesEffect>
                <mdb-icon fas icon="upload" class="mr-1"></mdb-icon>Guardar</button>
          </div>
          </div>
        </div>
        </mdb-card-body>
  </mdb-card>
  <br *ngIf="maeConstanciaE.c_estado==31 || maeConstanciaE.c_estado==34">
  <div *ngIf="maeConstanciaE.c_estado==31 || maeConstanciaE.c_estado==34" class="justify-content-center" style="text-align: center;">
    <button mdbBtn type="button" (click)="onGrabar()" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
        <mdb-icon fas icon="save" class="mr-1"></mdb-icon>Grabar</button>
  </div>
  <br *ngIf="esupdate">
  <mdb-card *ngIf="esupdate">
    <mdb-card-header>Firmantes</mdb-card-header>
    <mdb-card-body>
      <button *ngIf="maeConstanciaE.c_estado == 31" mdbBtn type="button" (click)="onAgregarFirmante()" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>Agregar Firmante</button>
      <div class="table-responsive">
        <table mdbTable hover="true">
          <thead>
            <tr>
              <th scope="col">Nro</th>
              <th scope="col">Nombre</th>
              <th scope="col">Oficina</th>
              <th scope="col" *ngIf="maeConstanciaE.c_estado == 31">Eliminar</th>
            </tr>
          </thead>
          <tbody>
            <tr mdbTableCol *ngFor="let listFirmanteM of listFirmantesM;let i = index">
              <th>{{listFirmanteM.n_secuencia}}</th>
              <th>{{listFirmanteM.x_usuario}}</th>
              <th>{{listFirmanteM.x_oficina}}</th>
              <td *ngIf="listFirmanteM.n_secuencia == listFirmantesM.length && maeConstanciaE.c_estado == 31"><button type="button" color="link"
                (click)="onDeleteFirmante(listFirmanteM)" class="btn-sm btn-sm-icon" mdbWavesEffect mdbBtn>
                <mdb-icon fas icon="minus-square" size="2x" class="blue-text pr-3"></mdb-icon></button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </mdb-card-body>
  </mdb-card>
  <br *ngIf="esupdate  && (maeConstanciaE.c_estado == 31 || maeConstanciaE.c_estado==34)">
  <div class="justify-content-center" style="text-align: center;" *ngIf="esupdate && maeConstanciaE.c_estado == 31">
    <button mdbBtn type="button"  size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
        <mdb-icon fas icon="trash" class="mr-1"></mdb-icon>Eliminar</button>
  </div>
  <!--Footer-->

